/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  LinkedInButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink,
  LinkedInImage,
} from "./NavbarStyledComponent";
import { DiCode } from "react-icons/di";
import { FaBars, FaGithub } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { Bio } from "../../data/constants";

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      event.target !== buttonRef.current
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "white",
              cursor: "pointer",
            }}
          >
            <DiCode size="3rem" />
            <Span>VALENTYN ARKHO</Span>
          </div>
        </NavLogo>

        <MobileIcon>
          {!isOpen ? (
            <div ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
              <FaBars />
            </div>
          ) : (
            <AiOutlineClose onClick={() => setIsOpen(!isOpen)} />
          )}
        </MobileIcon>

        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#storypoker">StoryPoker</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#certificates">Certificates</NavLink>
          <NavLink href="#education">Education</NavLink>
        </NavItems>

        <ButtonContainer>
          <LinkedInButton
            href={Bio.linkedin}
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
            <LinkedInImage src="https://cdn-icons-png.flaticon.com/256/174/174857.png" />
          </LinkedInButton>

          <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer">
            GitHub <FaGithub style={{ marginLeft: "6px" }} size={18} />
          </GitHubButton>
        </ButtonContainer>

        {isOpen && (
          <MobileMenu isOpen={isOpen} ref={menuRef}>
            <MobileLink href="#about" onClick={() => setIsOpen(false)}>
              About
            </MobileLink>
            <MobileLink href="#storypoker" onClick={() => setIsOpen(false)}>
              StoryPoker
            </MobileLink>
            <MobileLink href="#experience" onClick={() => setIsOpen(false)}>
              Experience
            </MobileLink>
            <MobileLink href="#skills" onClick={() => setIsOpen(false)}>
              Skills
            </MobileLink>
            <MobileLink href="#certificates" onClick={() => setIsOpen(false)}>
              Certificates
            </MobileLink>
            <MobileLink href="#education" onClick={() => setIsOpen(false)}>
              Education
            </MobileLink>

            <LinkedInButton
              style={{ padding: "10px 16px", width: "130px" }}
              href={Bio.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
              <LinkedInImage src="https://cdn-icons-png.flaticon.com/256/174/174857.png" />
            </LinkedInButton>

            <GitHubButton
              style={{ padding: "10px 16px", width: "112px" }}
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub <FaGithub style={{ marginLeft: "6px" }} size={18} />
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
